/**
 * The signature an email draft goes out with, under its body on the review
 * page – the mailbox's LTM signature file, appended when the seat creates the
 * mailbox draft and when the server sends it (Approve & send). No file on
 * record means the email goes out unsigned; the page says so instead of
 * leaving the owner to find out in the recipient's inbox.
 */
import DOMPurify from "dompurify";

import type { EmailSignature as Signature } from "../../api/admin";

export function EmailSignature({ signature }: { signature: Signature | null | undefined }) {
  if (!signature?.mailbox) return null;
  return (
    <section className="border-t border-rule mt-6 pt-5">
      <h2 className="font-heading font-semibold mb-1">Signature</h2>
      {signature.html ? (
        <>
          <p className="text-xs text-ink-low mb-3">
            Added under the email when it is drafted or sent – <span className="font-mono">{signature.mailbox}</span>.
          </p>
          <div
            className="email-signature"
            // The owner's own signature file, sanitized like every HTML the page renders.
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(signature.html, { FORBID_TAGS: ["img"] }) }}
          />
        </>
      ) : (
        <div className="callout callout--warn text-sm">
          No signature is on file for <span className="font-mono">{signature.mailbox}</span> – the email goes out
          without one. A signature is the file <span className="font-mono">ltm/user/email_signature/{signature.mailbox}.html</span>.
        </div>
      )}
    </section>
  );
}
